'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { createContext } from 'react';

// Types
import { WorkspaceLayoutContextValue } from './types';

/* -------------------------------------------------------------------------- */
/*                                   Context                                  */
/* -------------------------------------------------------------------------- */

const WorkspaceLayoutContext = createContext<WorkspaceLayoutContextValue>({
  workspace: undefined,
  me: undefined,
});

const WorkspaceLayoutProvider = WorkspaceLayoutContext.Provider;

export { WorkspaceLayoutContext, WorkspaceLayoutProvider };
